import { MagicConfigMixin, ModalMixin, magicConfig, SessionChange, RoutablePage } from '@gig/magic-common';
import { Mixins, Prop, Watch, Emit, Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { magic } from '@gig/magic-sdk';
import { USER_SET_REQUIRES_TERMS_ACCEPTANCE, USER_JURISDICTION_QUERY } from '@gig/magic-messages';
import { CONSENTS_NAMESPACE } from '../../../store/modules/consents/consents.store.js';
import { store } from '../../../store/index.js';
import { Jurisdiction } from '@gig/magic-jurisdictions';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const consentsModule = namespace(CONSENTS_NAMESPACE);
let TermsUpdatedPrompterComponent = class extends Mixins(MagicConfigMixin, ModalMixin) {
  render() {
    return null;
  }
  handleSessionChange(isLoggedIn) {
    const user = magic.session.getUser();
    if (isLoggedIn && user) {
      const timeRegistered = Date.parse(user.createdDate + "Z");
      const isNewUser = Date.now() - timeRegistered <= 6e4;
      if (isNewUser) {
        return;
      }
      this.fetchPendingConsents(magicConfig.language);
    } else {
      this.clearPendingConsents();
    }
  }
  publishPendingConsents() {
    const hasPending = this.pendingConsents.length > 0;
    window.commandBus.publish(USER_SET_REQUIRES_TERMS_ACCEPTANCE, hasPending);
  }
  checkModalStatus() {
    const hasPending = this.pendingConsents.length > 0;
    if (hasPending && !this.shouldHide) {
      this.openTermsModal();
    } else {
      this.closeModal();
    }
    return hasPending;
  }
  openTermsModal() {
    if (this.hasModal()) {
      return true;
    }
    const modalElement = this.openModal(this.renderedModal, null, {
      dismissible: false,
      keepAfterClear: true
    });
    modalElement.addEventListener("acceptedTerms", () => __async(this, null, function* () {
      this.clearPendingConsents();
      this.closeModal();
      const preferences = yield magic.methods.users.getPreferences();
      const isSGA = (yield window.queryBus.query(USER_JURISDICTION_QUERY)) === Jurisdiction.SGA;
      if (!preferences.limitsConfirmed && isSGA) {
        this.routeTo({ route: RoutablePage.SET_LIMITS });
      }
    }));
    modalElement.consents = this.pendingConsents;
    return true;
  }
};
__decorateClass([
  Prop({
    type: String,
    default: "magic-terms-updated-prompt"
  })
], TermsUpdatedPrompterComponent.prototype, "renderedModal", 2);
__decorateClass([
  Prop(Boolean)
], TermsUpdatedPrompterComponent.prototype, "shouldHide", 2);
__decorateClass([
  consentsModule.Action("fetchPendingConsents")
], TermsUpdatedPrompterComponent.prototype, "fetchPendingConsents", 2);
__decorateClass([
  consentsModule.Action("clearPendingConsents")
], TermsUpdatedPrompterComponent.prototype, "clearPendingConsents", 2);
__decorateClass([
  consentsModule.Getter("pendingConsents")
], TermsUpdatedPrompterComponent.prototype, "pendingConsents", 2);
__decorateClass([
  SessionChange({ immediate: true })
], TermsUpdatedPrompterComponent.prototype, "handleSessionChange", 1);
__decorateClass([
  Watch("pendingConsents")
], TermsUpdatedPrompterComponent.prototype, "publishPendingConsents", 1);
__decorateClass([
  Watch("pendingConsents"),
  Watch("shouldHide"),
  Emit("hasPendingConsents")
], TermsUpdatedPrompterComponent.prototype, "checkModalStatus", 1);
TermsUpdatedPrompterComponent = __decorateClass([
  Component({
    name: "terms-updated-prompter",
    store
  })
], TermsUpdatedPrompterComponent);

export default TermsUpdatedPrompterComponent;
